import {Observable} from 'rxjs/Observable';
import {ServiceErrorMapper} from './mapper/service-error.mapper';
import {ServiceError} from '../model/errors/service-error.model';

const BUFFER_SIZE = 1;
export abstract class BaseService<T, K> {
  private _errorMapper: ServiceErrorMapper;
  private _cacheDuration: number;
  private _genericObservables: Map<string, Observable<T>>;

  constructor(errorMapper: ServiceErrorMapper, cacheDuration: number) {
    this._errorMapper = errorMapper;
    this._cacheDuration = cacheDuration;
    this._genericObservables = new Map<string, Observable<T>>();
  }

  protected getByKey(key: K, useCache: boolean): Observable<T> {
    const observableKey: string = this.generateKey(key);
    let genericObservable:  Observable<T> = this._genericObservables[observableKey];
    if (!useCache || !genericObservable) {
      genericObservable = this.getFreshObservable(key)
        .shareReplay(BUFFER_SIZE, this._cacheDuration);
      this._genericObservables[observableKey] = genericObservable;
    }
    return genericObservable;
  }

  protected mapError(error: any): ServiceError {
    return this._errorMapper.map(error);
  }
  protected abstract generateKey(key: K): string;
  protected abstract getFreshObservable(key: K): Observable<T>;
  protected updateFreshObservable(key: K, value: Observable<T>): Observable<T> {
    const observableKey: string = this.generateKey(key);
    this._genericObservables[observableKey] = value;
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/base.service.ts